import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { stack as Menu } from 'react-burger-menu'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faUser, faCogs, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons'
import ScrollUpButton from "react-scroll-up-button";
import Switch from "react-switch";
import ReactCountryFlag from "react-country-flag";
import ReactPlayer from 'react-player/youtube';

export default class Master extends Component {
    constructor(props) {
        super(props);
        this.state = {
            enlarge: false,
            language: false,
        }
        this.enlargeImage = this.enlargeImage.bind(this);
        this.scrollToTop = this.scrollToTop.bind(this);
        this.handleLanguage = this.handleLanguage.bind(this);
    }

    componentDidMount() {
        let current_language = localStorage.getItem('language') == 'true';
        this.setState({
            language: current_language
        });
        // alert(JSON.stringify(this.props.path))
    }

    scrollToTop() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    handleLanguage() {
        let current_language = !this.state.language;
        this.setState({
            language: current_language
        });
        localStorage.setItem('language', current_language);
    }

    enlargeImage(e) {
        e.stopPropagation();
        this.setState({
            enlarge: !this.state.enlarge
        });
    }

    render() {
        return (
            <Fragment id="outer-container">
                <ScrollUpButton
                    StopPosition={0}
                    ShowAtPosition={150}
                    EasingType='easeOutCubic'
                    AnimationDuration={800}
                    ContainerClassName='ScrollUpButton__Container'
                    TransitionClassName='ScrollUpButton__Toggled'
                    style={{
                        backgroundColor: "rgba(0, 133, 191,0.45)",
                        color: "rgba(255,255,255,0.5)"
                    }}
                    ToggledStyle={{}}
                />
                <Menu pageWrapId={"page-wrap"} outerContainerId={"outer-container"} >
                    <img src="/images/logo.png" className="img-fluid mt-minus-25" />
                    <label htmlFor="small-radius-switch" className="pr-4">
                        <strong className="">{`${this.state.language ? 'Language' : 'Bahasa  '} `}</strong>
                        <Switch
                            offColor="#0085BF"
                            onColor="#0085BF"
                            checked={this.state.language}
                            onChange={this.handleLanguage}
                            uncheckedIcon={
                                <ReactCountryFlag code="id" svg styleProps={{
                                    borderRadius: "50%",
                                    width: "92%",
                                    height: "100%",
                                    marginRight: "8%",
                                }} />
                            }
                            checkedIcon={
                                <ReactCountryFlag code="gb" svg styleProps={{
                                    borderRadius: "50%",
                                    width: "95%",
                                    height: "100%",
                                    marginLeft: "5%",
                                }} />
                            }
                            className="react-switch"
                            id="icon-switch"
                        />
                    </label>
                    <Link to='/' className={`${this.props.path == "/" ? "link-decor-active" : ""}`}>
                        <FontAwesomeIcon icon={faHome} />
                        <span className="">
                            {this.state.language ? ` Home` : ` Beranda`}
                        </span>
                    </Link>
                    <Link to='/profile' className={`${this.props.path == "/profile" ? "link-decor-active" : ""}`}>
                        <FontAwesomeIcon icon={faUser} />
                        <span className="">
                            {this.state.language ? ` Profile` : ` Profil`}
                        </span>
                    </Link>
                    <Link to='/projects' className={`${this.props.path == "/projects" ? "link-decor-active" : ""}`}>
                        <FontAwesomeIcon icon={faCogs} />
                        <span className="">
                            {this.state.language ? ` Projects` : ` Proyek`}
                        </span>
                    </Link>
                    <Link to='/contact' className={`${this.props.path == "/contact" ? "link-decor-active" : ""}`}>
                        <FontAwesomeIcon icon={faMapMarkerAlt} />
                        <span className="">
                            {this.state.language ? ` Contact` : ` Kontak`}
                        </span>
                    </Link>
                    <Link to='/careers' className={`${this.props.path.startsWith("/careers") ? "link-decor-active" : ""}`}>
                        <FontAwesomeIcon icon={faMapMarkerAlt} />
                        <span className="">
                            {this.state.language ? ` Career` : ` Karir`}
                        </span>
                    </Link>
                </Menu>
                <Fragment id="page-wrap">
                    <div className="row bg-light w-100 m-0">
                        <div className="col-4 col-sm-3 p-3 pb-md-0">
                            <img src="/images/logo.png" className="img-fluid" />
                        </div>
                        <div className="col d-none d-md-block">
                            <div className="row align-items-center h-100 ">
                                <div className="col text-right">
                                    <label htmlFor="small-radius-switch" className="pr-4">
                                        <span className="">{`${this.state.language ? 'Language' : 'Bahasa  '} `}</span>
                                        <Switch
                                            offColor="#0085BF"
                                            onColor="#0085BF"
                                            checked={this.state.language}
                                            onChange={this.handleLanguage}
                                            uncheckedIcon={
                                                <ReactCountryFlag code="id" svg styleProps={{
                                                    borderRadius: "50%",
                                                    width: "92%",
                                                    height: "100%",
                                                    marginRight: "8%",
                                                }} />
                                            }
                                            checkedIcon={
                                                <ReactCountryFlag code="gb" svg styleProps={{
                                                    borderRadius: "50%",
                                                    width: "95%",
                                                    height: "100%",
                                                    marginLeft: "5%",
                                                }} />
                                            }
                                            className="react-switch"
                                            id="icon-switch"
                                        />
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row w-100 h-10 justify-content-center">
                        <div className="col bg-light pr-0">
                            <div className="row pl-3  d-none d-md-flex">
                                <Link to='/' className="col text-center active link pb-4">
                                    <span className={`${this.state.language ? "ml-3" : ""} link-decor ${this.props.path == "/" ? "link-decor-active" : ""}`}>
                                        {this.state.language ? ` Home` : ` Beranda`}
                                    </span>
                                </Link>
                                <Link to='/profile' className={`col text-center link pb-4 ${this.state.language ? "pl-0" : "ml-3"}`}>
                                    <span className={`link-decor ${this.props.path == "/profile" ? "link-decor-active" : ""}`}>
                                        {this.state.language ? ` Profile` : ` Profil`}
                                    </span>
                                </Link>
                                <Link to='/projects' className="col text-center link pb-4">
                                    <span className={`link-decor ${this.props.path == "/projects" ? "link-decor-active" : ""}`}>
                                        {this.state.language ? ` Projects` : ` Proyek`}
                                    </span>
                                </Link>
                                <Link to='/contact' className="col text-center link pb-4">
                                    <span className={`link-decor ${this.props.path == "/contact" ? "link-decor-active" : ""}`}>
                                        {this.state.language ? ` Contact` : ` Kontak`}
                                    </span>
                                </Link>
                                <Link to='/careers' className="col text-center link pb-4">
                                    <span className={`link-decor ${this.props.path.startsWith("/careers") ? "link-decor-active" : ""}`}>
                                        {this.state.language ? ` Career` : ` Karir`}
                                    </span>
                                </Link>

                            </div>
                        </div>
                        <div className="col d-none d-md-block pr-0">
                            <div className="row w-100 h-50 zindex-background bg-light ml-0">
                            </div>
                            <div className="row w-100 h-50 zindex-background bg-blue-secondary ml-0">
                            </div>
                        </div>
                    </div>

                    <div className="row w-100 h-100 zindex-background">
                        {/* <CSSTransition appear in timeout={3750} classNames="header-image"> */}
                        <div className="col-9 bg-information pr-0  bg-primary zindex-background">
                            {/* <CSSTransition appear in timeout={2000} classNames="header-image"> */}
                            {/* <div>
                                    {"I'll receive my-node-* classes"}
                                    </div> */}
                            {this.props.path === '/' &&
                                <img src="/images/profile.jpg" className="mw-100 img-blue" />
                            }
                            {this.props.path === '/profile' &&
                                <img src="/images/profile-header.jpg" className="mw-100 img-blue" />
                            }
                            {this.props.path === '/projects' &&
                                <img src="/images/proyek-header.jpg" className="mw-100 img-blue"/> 
                            }
                            {this.props.path === '/contact' &&
                                <img src="/images/contact-header.jpg" className="mw-100 img-blue" />
                            }
                            {this.props.path.startsWith('/careers') &&
                                <img src="/images/career-header.png" className="mw-100 img-blue" />
                            }
                        </div>
                        {/* </CSSTransition> */}
                        <div className="col bg-blue-secondary  zindex-background">
                            <div className="row bg-light h-10 d-md-none"></div>
                            <div className="row bg-blue-secondary h-90 d-md-none"></div>
                        </div>
                    </div>

                    <div className="row w-100 height-40 zindex-background">
                        <div className="col bg-light"></div>
                        <div className="col bg-blue-secondary"></div>
                    </div>

                    <div className="row w-100 height-40 zindex-background position-absolute t-100">
                        <div className="col"></div>
                        <div className="col text-center zindex-modal">
                            <h1 className="p-4 p-sm-5 text-light text-responsive-7">
                                {this.props.path === '/' &&
                                    `Sinergi Karya Sejahtera`
                                }
                                {this.props.path === '/projects' &&
                                    `${this.state.language ? 'Projects' : 'Proyek'}`
                                }
                                {this.props.path === '/profile' &&
                                    `${this.state.language ? 'Profile' : 'Profil'}`
                                }
                                {this.props.path === '/contact' &&
                                    `${this.state.language ? 'Contact' : 'Kontak'}`
                                }
                                {this.props.path.startsWith('/careers') &&
                                    `${this.state.language ? 'Career' : 'Karir'}`
                                }
                            </h1>
                        </div>
                    </div>

                    {
                        this.state.language ?
                            this.props.bodyEnglish
                            :
                            this.props.bodyIndonesian
                    }

                    {
                        this.state.enlarge
                        &&
                        <div className="my-modal p-5" onClick={this.enlargeImage} >
                            <img src="/images/iso.png" className="img-fluid  box-shadow" onMouseOut={this.enlargeImage}></img>
                        </div>
                    }

                    <footer class="page-footer font-small bg-black pt-3 mt-2">
                        <div className="row justify-content-center p-2">
                            <div className="col-sm-4 pl-5 pr-5">
                                <h4 className="text-white text-center text-sm-left">{this.state.language ? 'Contact Us' : `Hubungi Kami`}</h4>
                                <ul className="list-unstyled  text-center text-sm-left">
                                    <Link to="/contact">
                                        <li>Jl. Pangeran Jayakarta No.143 L Jakarta Pusat 10730</li>
                                    </Link>
                                    <Link to="/contact">
                                        <li>☏ +62 21 649 3347 | 649 5627</li>
                                    </Link>
                                    <Link to="/contact">
                                        <li>🖶 +62 21 626 1076</li>
                                    </Link>
                                    <a href="mailto:sinergikaryasejahtera@gmail.com">
                                        <li>sinergikaryasejahtera@gmail.com</li>
                                    </a>
                                </ul>
                            </div>
                            <div className="col-sm-4 justify-content-center text-center p-2">
                                <img src="/images/iso.png" height="150px" className="cursor-pointer box-shadow grow" onClick={this.enlargeImage} ></img>
                            </div>
                            <div className="col-lg-4 text-white px-5">
                                <h4 className="text-white text-center text-lg-left">{this.state.language ? `Legals` : `Legalitas`}</h4>
                                <ul className="pl-2 text-center text-lg-left list-unstyled">
                                    <small>
                                        <li>
                                            Akta pengukuhan No. 07 tanggal 01 Juni 2015
                                        </li>
                                        <li>
                                            Surat Ijin Usaha Perdagangan (SIUP) No. 01561/24.1.0/31.71-02.1005/1.824.271/2015
                                        </li>
                                        <li>
                                            Tanda Daftar Perusahaan Perseroan Terbatas No. 0223/24.3.0/31.71.02.1005/1.824.271/2016
                                        </li>
                                        <li>
                                            Surat Pengukuhan Perusahaan kena Pajak No. S-1756PKP/WPJ.06/KP.0403/2015
                                        </li>
                                        <li>
                                            Pokok Wajib Pajak ( NPWP) 73.348.814.2-026.000
                                        </li>
                                        <li>
                                            Surat Keterangan Domisili Perusahaan No. 250/27.1BU.1/31.71.02.1005/-071.562/e/2017
                                        </li>
                                        <li>
                                            Keputusan Menteri Hukum dan Hak Asazi Manusia Republik Indonesia No. AHU - 2445674.AH.01.01. Tahun 2015
                                        </li>
                                    </small>
                                </ul>
                            </div>
                        </div>

                        <div class="footer-copyright text-center py-1 px-2 text-white bg-black">
                            <small className="small ">
                                © 2019 Copyright PT. Sinergi Karya Sejahtera |
                            </small>
                            <small className="small">{` Design & Development by Vincent Lioe`}</small>
                        </div>
                    </footer>
                </Fragment>
            </Fragment>
        );
    }

}